import React from 'react'
import { useDispatch } from 'react-redux'
import * as Styles from './style'
import { toast } from 'react-toastify'
import { getAllClusters } from '../../../reduxLogic/reducers/clusters/getAllClustersSlice'
import { deleteCluster } from '../../../reduxLogic/reducers/clusters/deleteClusterSlice'

const DeleteModal = props => {
  const { idToDelete, clusterToDelete, traineeCount = 0, setDeleteModal } = props
  let dispatch = useDispatch()

  const handleDeleteProject = () => {
    if (traineeCount > 0) {
      toast.warning(`Cannot delete this cluster! It has ${traineeCount} active trainees assigned.`)
      setDeleteModal(false)
      return
    }

    dispatch(deleteCluster(idToDelete))
      .then(() => dispatch(getAllClusters()))
      .then(() => setDeleteModal(false))
      .then(() => toast.success('Cluster deleted successfully'))
      .catch(err => toast.error(`Error deleting cluster: ${err?.message || err}`))
  }

  const handleCloseModal = () => {
    setDeleteModal(false)
  }

  return (
    <Styles.ModalWrapper>
      <Styles.ModalContent>
        <Styles.InnerContainer>
          {traineeCount > 0 ? (
            <>
              <h3 style={{ color: '#d63031' }}>⚠️ Cannot Delete Cluster</h3>
              <p style={{ fontSize: '14px', color: '#636e72', margin: '12px 0 20px' }}>
                This cluster has <b>{traineeCount}</b> assigned trainee(s). You cannot delete it until all trainees are reassigned to another cluster or removed.
              </p>
              <Styles.ButtonDiv>
                <Styles.CloseButton onClick={handleCloseModal}>
                  Close
                </Styles.CloseButton>
              </Styles.ButtonDiv>
            </>
          ) : (
            <>
              <h3>Are you sure you want to delete this cluster?</h3>
              {clusterToDelete && (
                <div
                  style={{
                    backgroundColor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    padding: '10px 14px',
                    margin: '12px 0 18px',
                    textAlign: 'left',
                    fontSize: '13px',
                    color: '#334155',
                  }}
                >
                  <div><b>Cluster ID:</b> {clusterToDelete.clusterId}</div>
                  <div style={{ marginTop: '4px' }}><b>Cluster Name:</b> {clusterToDelete.clusterName}</div>
                </div>
              )}
              <Styles.ButtonDiv>
                <Styles.DeleteButton onClick={handleDeleteProject}>
                  Yes, Delete
                </Styles.DeleteButton>
                <Styles.CloseButton onClick={handleCloseModal}>
                  Cancel
                </Styles.CloseButton>
              </Styles.ButtonDiv>
            </>
          )}
        </Styles.InnerContainer>
      </Styles.ModalContent>
    </Styles.ModalWrapper>
  )
}

export default DeleteModal
